import payoutRequests from 'top20common/distribution/services/payout-requests';

export default {
  fetchPayoutRequestsAction(context) {
    return new Promise((resolve, reject) => {
      payoutRequests
        .fetchPayoutRequests()
        .then(response => {
          context.commit('setPayoutRequestsListState', response.data.results);
          resolve(response);
        })
        .catch(errors => {
          reject(errors);
        });
    });
  },
  createPayoutRequestAction(context) {
    context.commit('setCreateLoadingState', true);
    return new Promise((resolve, reject) => {
      payoutRequests
        .createPayoutRequest()
        .then(response => {
          context.commit('mutatePayoutRequestsListState', response.data);
          context.commit('mutateTokensMetaState', {current_balance: 0});
          resolve(response);
        })
        .catch(errors => {
          reject(errors);
        })
        .finally(() => {
          context.commit('setCreateLoadingState', false);
        });
    });
  }
};
